// @flow

import React from 'react';
import { Redirect as RouterRedirect } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';

type Props = InjectIntlProvidedProps & {
  to: string,
};

const Redirect = (props: Props) => {
  return <RouterRedirect {...props} to={`/${props.intl.locale}${props.to}`} />;
};

export default injectIntl(Redirect);
